<template>
  <div :class="s.background" v-sound>
    <div :class="s.title">
      <img :class="s.productImage" src="/img/menu/cash-register.png" alt="レジ画像" />
      <p>ご来店<br>ありがとうございました！</p>
      
      <div :class="s.subtitle">
        <p>レジにお進みください</p>
      </div>
      
      <div :class="s.container">
        <button :class="s.closeButton" @click="goToTop">トップに戻る</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  created() {
    this.axios({
      method: 'GET',
      url: '/v1/connection/test',
    })
      .then((response) => {
        console.log(response.data.status);
      })
      .catch((error) => {
        if (error.response) console.log(error.response.data);
        else console.log(error);
      });
  },
  methods: {
    goToTop() {
      // QRコードセッションの場合は情報をクリアする
      if (localStorage.getItem('isQrSession')) {
        localStorage.removeItem('diningTableID');
        localStorage.removeItem('deviceUUID');
        localStorage.removeItem('isQrSession');
        // 必要であればVuexのログイン状態などもリセットする
        // this.$store.commit('user/login/setIsLogin', false);
      }
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" module="s">
.background {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.productImage {
  width: 45vw;
  height: 45vh;
  object-fit: contain;
  margin-bottom: -8vh;
}

.title {
  color: #836131;
  font-family: 'HGS明朝B', 'HGS明朝E', 'HGS明朝C', serif;
  font-size: 70px;
  text-align: center;
  font-weight: bold;
  line-height: 1.2;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateY(-40px);
}

.subtitle {
  color: #836131;
  font-family: '游明朝', serif;
  font-size: 40px;
  text-align: center;
  font-weight: bold;
  line-height: 1.4;
  margin-top: 10px;
}

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3vh;
}

.closeButton {
  background-color: #B03A2E;
  color: #FFFFFF;
  font-family: 'HGS明朝B', 'HGS明朝E', 'HGS明朝C', serif;
  font-size: 3vw;
  padding: 5vh 10vw;
  border: none;
  border-radius: 16px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  outline: none;
}

@media (max-width: 768px) {
  .title {
    font-size: 32px; /* モバイルでのタイトルサイズ縮小 */
  }
  .subtitle {
    font-size: 24px; /* モバイルでのサブタイトルサイズ縮小 */
  }
  .closeButton {
    font-size: 24px; /* モバイルでのボタン文字サイズ調整 */
    padding: 16px 60px; /* タップしやすいようにパディング調整 */
  }
  .productImage {
    width: 60vw; /* モバイル画像サイズ調整 */
    height: 35vh;
  }
}
</style>
